import React, { useEffect, useState } from "react";
import "./Profile.css";
import axios from "axios";
import useAuth from "../../hooks/useAuth";
import { BASE_URL } from "../../utils/Element";
import BaseLayout from "../../layouts/BaseLayout";
import { NotificationManager } from "react-notifications";
import UserProfile from "../../components/ProfileComponents/UserProfile";
import { useDispatch } from "react-redux";

const Profile = () => {
  const dispatch = useDispatch();
  const [config] = useAuth();
  const [userData, setUserData] = useState();
  const [loading, setLoading] = useState(true);

  const fetchProfile = () => {
    setLoading(true);
    axios
      .get(`${BASE_URL}/get-profile`, config)
      .then((res) => {
        setUserData(res?.data?.data);
        dispatch(setUserData(res?.data?.data));
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  return (
    <BaseLayout>
      <p className="head-1 dark-H">My Profile</p>
      <UserProfile from="profile" loading={loading} userData={userData} fetchProfile={fetchProfile} />
    </BaseLayout>
  );
};

export default Profile;
